import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function useCompanyInfo() {
  const [companyInfo, setCompanyInfo] = useState({
    system_name: 'Laundry Manager',
    system_subtitle: 'Hotel Linen System',
    company_name: '',
    address: '',
    phone: '',
    email: '',
    abn: '',
    website: '',
    notes: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await axios.get(`${API}/api/company-info`);
        setCompanyInfo(response.data);
      } catch (error) {
        console.error('Failed to fetch company info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyInfo();
  }, []);

  return { companyInfo, loading };
}
